import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';

import { useReducer, useRef } from "react";

var getVarValue = function (value) {
    if (typeof value === 'function') {
        return value();
    }
    else {
        return value;
    }
};


export function GetTextInputObj ({ id, name, value, label, description, title, placeholder, required, isInvalid, errors, isValid, successMsgs, disabled, readOnly, hideFieldOrgTypes, maxLength }) {
    var textInputObj = {
        type: 'text',
        id: id,
        name: name,
        value: value,
        display: {
            label: label,
            description: getVarValue(description),
            title: getVarValue(title),
            placeholder: getVarValue(placeholder),
            maxLength: getVarValue(maxLength)
        },
        validation: {
            required: getVarValue(required),
            isInvalid: isInvalid,
            errors: errors,
            isValid: isValid,
            successMsgs: successMsgs
        },
        disabled: getVarValue(disabled),
        readOnly: getVarValue(readOnly),
        hideFieldOrgTypes: hideFieldOrgTypes,
        InputRef: useRef(null)
    };

    return useReducer(textInputDataReducer, textInputObj);
}

export function GetFeedbackTextInputData (fieldName, fieldValue) {
    switch (fieldName) {
        case 'firstName':
            return GetTextInputObj({
                id: 'feedback_' + fieldName,
                name: 'feedback_' + fieldName,
                value: fieldValue,
                label: 'First Name',
                description: null,
                title: '',
                placeholder: 'Enter your first name',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
        case 'lastName':
            return GetTextInputObj({
                id: 'feedback_' + fieldName,
                name: 'feedback_' + fieldName,
                value: fieldValue,
                label: 'Last Name',
                description: null,
                title: '',
                placeholder: 'Enter your last name',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
        case 'email':
            return GetTextInputObj({
                id: 'feedback_' + fieldName,
                name: 'feedback_' + fieldName,
                value: fieldValue,
                label: 'Email',
                description: null,
                title: '',
                placeholder: 'Please provide an email address to confirm receipt of comments.',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
        case 'organization':
            return GetTextInputObj({
                id: 'feedback_' + fieldName,
                name: 'feedback_' + fieldName,
                value: fieldValue,
                label: 'Organization',
                description: null,
                title: '',
                placeholder: 'Enter your organization name',
                required: true,
                isInvalid: false,
                errors: [],
                isValid: false,
                successMsgs: [],
                disabled: false,
                readOnly: false,
                hideFieldOrgTypes: [],
                maxLength: 100
            });
    }

}